import { FooterTypes } from '..';

export const getTextColor = (theme: FooterTypes.TThemeModes) => {
  return theme === 'dark' ? 'secondary' : 'text-color-primary';
};

export const getSocialIconsColor = (theme: FooterTypes.TThemeModes) => {
  return theme === 'dark' ? 'has-text-white' : 'has-text-text-color-primary';
};
